import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { MERCHANT_ENTERPRISE_SERVICE, fetchEnterpriseAnalyticsDashboards } from 'apis/enterprise/api';

import useTimedRefetch from './useTimedRefetch';
import { useEnterpriseContext } from '../context/EnterpriseContext';

const useGetEnterpriseAnalyticsDashboards = () => {
  const { enterprise } = useEnterpriseContext();
  const intl = useIntl();
  const { data, error, isLoading, refetch, remove } = useQuery(
    [`${MERCHANT_ENTERPRISE_SERVICE}/enterprises/${enterprise?.id}/analytics-dashboards`, intl.locale],
    () => enterprise && fetchEnterpriseAnalyticsDashboards(enterprise?.id, intl.locale),
    {
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  const { refetchSoon, removeAndRefetch } = useTimedRefetch({ data, remove, refetch });

  return {
    data,
    error,
    isLoading,
    refetchSoon,
    removeAndRefetch,
  };
};

export default useGetEnterpriseAnalyticsDashboards;
